import React from "react";
import { Provider } from "react-redux";
import { store } from "./store";

// // // //

/**
 * The Redux Provider component that wraps the child components with the Redux store.
 */
export function ReduxProvider(props: { children: React.ReactNode }) {
    return <Provider store={store}>{props.children}</Provider>;
}
